import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Toggle Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Is checked Toggle
     */
    @Prop({ type: Boolean }) checked!: boolean;

    /**
     * Separate Toggle and Label
     */
    @Prop({ type: Boolean }) separated!: boolean;

    /**
     * Reverse the label and the Toggle
     */
    @Prop({ type: Boolean }) reversed!: boolean;

    /**
     * True Value
     */
    @Prop({ default: 1 }) trueValue!: boolean|number;

    /**
     * False Value
     */
    @Prop({ default: 0 }) falseValue!: boolean|number;
}

export default Props;
